var __assign = (this && this.__assign) || function () {
    __assign = Object.assign || function(t) {
        for (var s, i = 1, n = arguments.length; i < n; i++) {
            s = arguments[i];
            for (var p in s) if (Object.prototype.hasOwnProperty.call(s, p))
                t[p] = s[p];
        }
        return t;
    };
    return __assign.apply(this, arguments);
};
var __spreadArray = (this && this.__spreadArray) || function (to, from, pack) {
    if (pack || arguments.length === 2) for (var i = 0, l = from.length, ar; i < l; i++) {
        if (ar || !(i in from)) {
            if (!ar) ar = Array.prototype.slice.call(from, 0, i);
            ar[i] = from[i];
        }
    }
    return to.concat(ar || Array.prototype.slice.call(from));
};
import { jsx as _jsx, jsxs as _jsxs } from "react/jsx-runtime";
import { PencilIcon } from '@heroicons/react/24/outline';
import Table from '@web/components/layout/Table/Table';
import { EditUserModal } from '@web/components/Settings/Members/UsersSection/EditUserModal/EditUserModal';
import RoleBadge from '@web/components/Settings/Members/UsersSection/RoleBadge/RoleBadge';
import ToggleActiveUser from '@web/components/Settings/Members/UsersSection/ToggleActiveUser/ToggleActiveUser';
import UserAvatar from '@web/components/UserAvatar';
import { useUserContext } from '@web/contexts/User';
import { useWorkspaceCtx } from '@web/contexts/Workspace';
import { useState } from 'react';
import { useTranslation } from 'react-i18next';
var UsersSection = function (_a) {
    var users = _a.users, allOrgUnits = _a.allOrgUnits, refetch = _a.refetch;
    var t = useTranslation().t;
    var currentUser = useUserContext().currentUser;
    var allUsers = useWorkspaceCtx().users;
    var _b = useState(false), isEditUserModalVisible = _b[0], setIsEditUserModalVisible = _b[1];
    var _c = useState(null), selectedUser = _c[0], setSelectedUser = _c[1];
    var columns = __spreadArray([
        {
            title: t('usersSection.name'),
            isVisible: true,
            className: 'w-2/5 sm:px-3'
        },
        {
            title: t('usersSection.orgUnit'),
            isVisible: true,
            className: 'w-1/5 sm:px-3'
        },
        {
            title: t('usersSection.role'),
            isVisible: true,
            className: 'sm:px-3'
        }
    ], (currentUser && currentUser.isAdmin
        ? [
            {
                title: t('usersSection.edit'),
                isVisible: true,
                className: 'sm:px-3'
            },
            {
                title: _jsx("div", { className: "flex items-center" }),
                isVisible: true,
                className: 'sm:px-3'
            }
        ]
        : []), true);
    var tableData = users.map(function (user) { return __spreadArray([
        {
            id: "".concat(user.id, "-name"),
            render: function () { return (_jsxs("div", __assign({ className: 'flex flex-col justify-center md:flex-row md:justify-start items-start md:items-center' }, { children: [_jsx("div", __assign({ className: "flex-shrink-0 h-10 w-10 sm:mb-2 md:mb-0" }, { children: _jsx(UserAvatar, { size: 'large', user: user }) })), _jsxs("div", __assign({ className: "md:ml-4 text-left" }, { children: [_jsx("div", __assign({ className: "flex text-sm font-medium text-gray-900 pr-2" }, { children: _jsx("span", __assign({ className: "mr-1.5 md:mr-3  truncate w-36" }, { children: user.name })) })), _jsx("div", __assign({ className: "text-sm text-gray-500 break-all" }, { children: user.email }))] }))] }))); }
        },
        {
            id: "".concat(user.id, "-org-units"),
            render: function () { return (_jsx("p", __assign({ className: "text-xs text-gray-500 font-normal break-all" }, { children: user.userOrgUnits.map(function (orgUnit) { return orgUnit.orgUnit.title; }).join(', ') }))); }
        },
        {
            id: "".concat(user.id, "-role"),
            render: function () { return _jsx(RoleBadge, { role: user.role }); }
        }
    ], (currentUser && currentUser.isAdmin
        ? [
            {
                id: "".concat(user.id, "-edit"),
                render: function () { return (_jsx("div", __assign({ className: "flex justify-end w-full" }, { children: _jsx(PencilIcon, { className: "h-5 w-5 text-indigo-600 cursor-pointer hover:text-indigo-800 hover:scale-105", onClick: function () {
                            setSelectedUser(user);
                            setIsEditUserModalVisible(true);
                        } }) }))); }
            },
            {
                id: "".concat(user.id, "-action"),
                render: function () { return (_jsx(ToggleActiveUser, { user: user, currentUser: currentUser, refetch: refetch, usersActiveCount: allUsers.filter(function (user) { return user.isActive; }).length })); }
            }
        ]
        : []), true); });
    return (_jsxs("div", __assign({ className: "text-right" }, { children: [_jsx(Table, { columns: columns, data: tableData, columnsClassName: "bg-white" }), _jsx(EditUserModal, { visible: isEditUserModalVisible, onClose: function () {
                    setIsEditUserModalVisible(false);
                    setSelectedUser(null);
                }, user: selectedUser, refetch: refetch, allOrgUnits: allOrgUnits })] })));
};
export default UsersSection;
